<!--视频监控-->
<template>
  <div style="text-align: left">
    <div style="display: flex; align-items: center">
      <el-tabs v-model="activeName">
        <el-tab-pane :label="$t('videom.real_time_video')" name="second"></el-tab-pane>
        <el-tab-pane :label="$t('videom.history_video')" name="first"></el-tab-pane>
      </el-tabs>
      <div v-if="activeName === 'first'" style="flex: 1; text-align: right">
        <el-form :inline="true" size="small" style="flex: 1; text-align: right; margin-top: 8px">
          <el-form-item :label="$t('videom.select_vehicle')">
            <el-select style="width: 100%" filterable v-model="QueryVID" :placeholder="$t('public.select')">
              <el-option v-for="item in vehicleData" :key="item.DeviceNo" :label="item.CarNo" :value="item.DeviceNo">
              </el-option>
            </el-select>
          </el-form-item>
          <!--通道号选择-->
          <el-form-item :label="$t('videom.select_channel')">
            <el-select style="width: 100px" filterable v-model="QueryChannel" :placeholder="$t('public.select')">
              <el-option v-for="item in channelData" :key="item.ChannelNo" :label="item.ChannelNo" :value="item.ChannelNo">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker v-model="beginDate" type="date" style="width: 150px"
              :placeholder="$t('龙翼简报.选择日期')">
            </el-date-picker>
            <el-time-picker v-model="timeRange" is-range :range-separator="$t('time.to')"
              :start-placeholder="$t('time.startTimeHolder')" :end-placeholder="$t('time.endTimeHolder')">
            </el-time-picker>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" plain @click="queryVedioHistory">{{
              $t("public.query")
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div v-if="activeName === 'second'">
        <span style="
            margin-left: 6px;
            font-weight: normal;
            color: #ff8c00;
            font-size: 12px;
          "><kl-icon :size="12" icon="icon-icon_prompt2" />{{
            $t("videom.select_vehicle_first")
          }}</span>
      </div>
    </div>
    <div v-if="activeName === 'first'" style="margin-right: 10px">
      <HistoryVedioMgr ref="historyVedio" :QueryVehicleInfo="QueryVehicleInfo" />
    </div>
    <div v-if="activeName === 'second'" style="margin-right: 10px">
      <RealMonitorMgr ref="realVedio" />
    </div>
  </div>
</template>
<script>
import HistoryVedioMgr from "./components/HistoryVedioMgr";
import RealMonitorMgr from "./components/RealMonitorMgr";
import { mapState } from "vuex";
export default {
    name:"VedioMonitorMgr",
  components: { HistoryVedioMgr, RealMonitorMgr },
  data() {
    return {
      activeName: "second",
      loading: false,
      total: 100,
      tableData: [{}, {}, {}, {}],
      channelData:[
        {ChannelNo:1},
        {ChannelNo:2},
        {ChannelNo:3},
        {ChannelNo:4},
        {ChannelNo:5},
        {ChannelNo:6},
        {ChannelNo:7},
        {ChannelNo:8},
      ],
      QueryChannel: "1",
      vehicleData: [],
      form: {
        AreaName: "",
        PageNo: 1,
        PageSize: 10,
      },
      beginDate: "",
      timeRange: "",
      QueryVID: "",
      QueryVehicleInfo: {
        vehicleName: "",
        mobile: "",
        beginTime: "",
        endTime: "",
      },
    };
  },
  watch: {
    QueryVID(val) {
      var s = this.vehicleData.filter((item) => item.DeviceNo === val);
      console.log(s);
      if (s && s.length > 0) {
        this.QueryVehicleInfo.vehicleName = s[0].CarNo;
        this.QueryVehicleInfo.mobile = s[0].DeviceNo;
        //  this.QueryVehicleInfo.vehicleName = "NO11000093";
        // this.QueryVehicleInfo.mobile ="004011001426";
      }
    },
  },
  computed: {
    ...mapState({
      vehicles: (state) => state.app.vehicles,
    }),
    size() {
      return this.$store.getters.size;
    },
  },
  methods: {

    queryVideoDeviceNo() {
      this.$api.queryVideoDeviceNoByOptID().then(res => {
        if (res.code == 200) {
          this.vehicleData = res.data;
        }
      })
    },
    queryVedioHistory() {
      //参数，下发指令

      if (!this.QueryVehicleInfo.vehicleName) {
        this.$message.error(this.$t("videom.pls_select_vehicle"));
        return;
      }
      if (!this.beginDate || !this.timeRange) {
        this.$message.error(this.$t("time.selectQueryTime"));
        return;
      }
      var beginTime = "";
      var endTime = "";

      beginTime =
        this.moment(this.beginDate).format("yyyy-MM-DD") +
        " " +
        this.moment(this.timeRange[0]).format("HH:mm:ss");
      endTime =
        this.moment(this.beginDate).format("yyyy-MM-DD") +
        " " +
        this.moment(this.timeRange[1]).format("HH:mm:ss");

        //时间跨度不能超过1小时
        if (this.moment(endTime).diff(this.moment(beginTime), 'hours') > 1) {
          this.$message.error(this.$t("videom.查询时间不能超过1小时"));
          return;
        }

      this.QueryVehicleInfo.beginTime = beginTime;
      this.QueryVehicleInfo.endTime = endTime;
      this.QueryVehicleInfo.channel =this.QueryChannel
      //测试
      // this.QueryVehicleInfo.vehicleName = "模拟车辆";
      // this.QueryVehicleInfo.mobile = "004011000368";

      this.$refs.historyVedio.queryVedioHistory();
    },
  },
  mounted() {
    this.$store.dispatch("app/closeSideBar");
    this.queryVideoDeviceNo();
  },
  destroyed() {
    this.$store.dispatch("app/openSideBar");
  },
};
</script>
